import React from 'react'
import AnalyticsBarChart from '../analytics/charts/AnalyticsBarChart'

export type ErpBarSeries = {
 name?: string
 data: number[]
 color?: string
}

export type ErpBarChartProps = {
 categories: string[]
 series: ErpBarSeries[]
 height?: number
 layout?: 'vertical' | 'horizontal'
 showLegend?: boolean
 zeroBarMuted?: boolean
 borderRadius?: number
 valueFormatter?: (value: number) => string
 className?: string
}

/** @deprecated Use AnalyticsBarChart instead. */
const ErpBarChart: React.FC<ErpBarChartProps> = ({
 categories,
 series,
 height = 300,
 layout = 'vertical',
 showLegend = false,
 zeroBarMuted = false,
 valueFormatter,
 className,
}) => {
 return (
  <AnalyticsBarChart
   categories={categories}
   series={series.map((item) => ({
    name: item.name ?? '',
    data: item.data,
    color: item.color,
   }))}
   height={height}
   horizontal={layout === 'horizontal'}
   showLegend={showLegend}
   zeroBarMuted={zeroBarMuted}
   valueFormatter={valueFormatter}
   className={className}
  />
 )
}

export default ErpBarChart
